export const enum FinanceMonthPeriodFilter {
  all = 'all',
  first = '1st',
  second = '2nd',
}
